import { type VariantProps, cva } from 'class-variance-authority';

import classNames from '@/utils/classnames';

export const alertVariants = cva('rounded-lg border p-4 text-sm leading-relaxed', {
  variants: {
    variant: {
      info: 'border-info/30 bg-info-tint text-info',
      success: 'border-success/30 bg-success-tint text-success',
      warning: 'border-warning/40 bg-warning-tint text-warning',
      danger: 'border-danger/30 bg-danger-tint text-danger',
    },
  },
  defaultVariants: {
    variant: 'info',
  },
});

export interface AlertProps extends VariantProps<typeof alertVariants> {
  title?: React.ReactNode;
  icon?: React.ReactNode;
  className?: string;
  children?: React.ReactNode;
}

export function Alert({ variant, title, icon, className, children }: AlertProps) {
  return (
    <div role="alert" className={classNames(alertVariants({ variant }), className)}>
      {(title || icon) && (
        <div className="flex items-center gap-2 font-semibold">
          {icon}
          {title}
        </div>
      )}
      {children && <div className={title ? 'mt-1.5' : undefined}>{children}</div>}
    </div>
  );
}
